import isUndefined from 'lodash/isUndefined';
import isString from 'lodash/isString';

const $hnxStorage = function () {
	const storage = {};

	Object.defineProperty(storage, '$add', {
		configurable: false,
		writable: false,
		value (key, value) {
			if (!isString(key)) {
				throw new Error('Name must be a string!');
			}
			if (key.startsWith('$')) {
				throw new Error('Provided name is reserved!');
			}
			return this[key] = value;
		}
	});

	Object.defineProperty(storage, '$has', {
		configurable: false,
		writable: false,
		value (key) {
			return !isUndefined(this[key]);
		}
	});

	Object.defineProperty(storage, '$get', {
		configurable: false,
		writable: false,
		value (key, removeOnPick) {
			const val = this[key];
			if (removeOnPick) {
				delete this[key];
			}
			return val;
		}
	});

	Object.defineProperty(storage, '$remove', {
		configurable: false,
		writable: false,
		value (key) {
			if (key.startsWith('$')) {
				throw new Error('Cannot remove special properties!');
			}
			return delete this[key];
		}
	});

	Object.defineProperty(storage, '$clear', {
		configurable: false,
		writable: false,
		value (key) {
			if (key.startsWith('$')) {
				throw new Error('Cannot remove special properties!');
			}
			return delete this[key];
		}
	});

	Object.defineProperty(storage, '$clearAll', {
		configurable: false,
		writable: false,
		value () {
			const self = this;
			Object.keys(this).forEach((key) => {
				if (key.startsWith('$')) {
					return;
				}
				delete self[key];
			});
		}
	});

	Object.defineProperty(storage, '$purge', {
		configurable: false,
		writable: false,
		value () {
			this.$clearAll();
		}
	});
	
	return storage;
}();

export default $hnxStorage;
